import { lazy, Suspense } from "react";

// Lazy load the actual analytics content to avoid babel-metadata-plugin recursion
const AnalyticsContent = lazy(() => import("@/components/admin/AnalyticsContent"));

function AnalyticsPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#D4AF37]"></div>
      </div>
    }>
      <AnalyticsContent />
    </Suspense>
  );
}

export default AnalyticsPage;
